var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKingB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    d: "M 22.5,11.63 L 22.5,6 M 20,8 L 25,8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22.5,25 C 22.5,25 27,17.5 25.5,14.5 C 25.5,14.5 24.5,12 22.5,12 C 20.5,12 19.5,14.5 19.5,14.5 C 18,17.5 22.5,25 22.5,25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.5,37 C 17,40.5 27,40.5 32.5,37 L 32.5,30 C 32.5,30 41.5,25.5 38.5,19.5 C 34.5,13 25,16 22.5,23.5 L 22.5,27 L 22.5,23.5 C 19,16 9.5,13 6.5,19.5 C 3.5,25.5 11.5,29.5 11.5,29.5 L 11.5,37"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M 22.5,20 C 22.5,20 25.75,17 24.5,14.5 C 24.5,14.5 24,13 22.5,13 C 21,13 20.5,14.5 20.5,14.5 C 19.25,17 22.5,20 22.5,20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 32,29.5 C 32,29.5 40.5,25.5 38.03,19.85 C 34.15,14 25,18 22.5,24.5 L 22.51,26.6 L 22.5,24.5 C 20,18 9.906,14 6.997,19.85 C 4.5,25.5 11.85,28.85 11.85,28.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.5,30 C 17,27 27,27 32.5,30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.5,33.5 C 17,30.5 27,30.5 32.5,33.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.5,37 C 17,34 27,34 32.5,37"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKingB);
export default __webpack_public_path__ + "static/media/king-b.886b463eaae8fb2cfa6df0edd2ac8670.svg";
export { ForwardRef as ReactComponent };